import * as React from "react";
import type { SVGProps } from "react";
const SvgUserLogout = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M0 1a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V2H2v16h10v-3a1 1 0 1 1 2 0v4a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1zm16.293 4.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L18.586 11H10a1 1 0 1 1 0-2h8.586l-2.293-2.293a1 1 0 0 1 0-1.414"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgUserLogout;
